export const socialLinks = [
	{
		id: 1,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/allenapplehead',
	},
	{
		id: 2,
		name: 'Linkedin',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/allentao7/',
	},
	{
		id: 3,
		name: 'Mail',
		icon: 'mail',
		url: 'mailto:allen.tao@mail.utoronto.ca',
	},
	{
		id: 4,
		name: 'YouTube',
		icon: 'youtube',
		url: 'https://www.youtube.com/channel/UCHB6SeUT8tRKPbdgq9At18w',
	},
];
